module.exports = __webpack_public_path__ + "img/cash_assist_icon.8f58fd0b.svg";